/* Custom miscellaneous scripts */
// eslint-disable-next-line no-undef
jQuery(document).ready(function ($) {
	const childSidebar = $('.nav-section__list-item--has-children')
	$(childSidebar).click(function () {
		$(this).toggleClass('nav-section__list-item--is-active')
	})

	const stickyHeader = $('.sticky-header')
	$(window).scroll(function () {
		const scroll = $(window).scrollTop()

		if (scroll >= 300) {
			stickyHeader.css('opacity', '1')
			stickyHeader.css('visibility', 'visible')
		} else {
			stickyHeader.css('opacity', '0')
			stickyHeader.css('visibility', 'hidden')
		}
	})

	$(window).scroll(function () {
		const winScroll =
			document.body.scrollTop || document.documentElement.scrollTop
		const height =
			document.documentElement.scrollHeight -
			document.documentElement.clientHeight
		const scrolled = (winScroll / height) * 100
		const progress = document.getElementById('progress')
		progress ? (progress.style.width = scrolled + '%') : null
	})

	$('.masthead__trigger--site-nav').click(function () {
		if ($('#masthead').hasClass('masthead__nav--is-active')) {
			$('body').removeClass('no-scroll')
		} else {
			$('body').addClass('no-scroll')
		}
	})

	$(window).resize(function () {
		if ($(window).width() > 898) {
			$('body').removeClass('no-scroll')
			$('header').removeClass('masthead__nav--is-active')
		}
	})
})

import ready from './core/ready'

ready()
